<template>
    <main class="moviePage" v-if="isLoadingMovie">
        <section class="skeleton">
            <div class="skeleton__container container">
                <div class="skeleton__wrapper">
                    <div class="skeleton__right">
                        <div class="skeleton__left_wrapperImg">
                            <div class="skeleton__left_img">
                                <div class="img"></div>
                            </div>
                        </div>
                        <div class="skeleton__right_title"></div>
                        <div class="skeleton__right_items">
                            <div class="skeleton__right_items_item"></div>
                            <div class="skeleton__right_items_item"></div>
                            <div class="skeleton__right_items_item"></div>
                            <div class="skeleton__right_items_item"></div>
                        </div>
                        <div class="skeleton__right_btn"></div>
                        <div class="skeleton__miniBtns">
                            <div
                                class="skeleton__miniBtns__item"
                                v-for="i in 4"
                            >
                                <div
                                    class="skeleton__miniBtns__item_icon"
                                ></div>
                                <div
                                    class="skeleton__miniBtns__item_text"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
    <main class="moviePage" v-else>
        <section class="section hero">
            <div class="background" ref="parallax" v-if="movie">
                <div class="background__img">
                    <img
                        :src="
                            movie.posterSmallSrc
                                ? movie.posterSmallSrc
                                : noImageAvailable
                        "
                        :alt="movie.name"
                        v-if="!(movie.trailer && windowWidth > 992)"
                        draggable="false"
                    />
                    <PlayTrailerBg
                        v-else-if="movie.trailer"
                        :link="movie.trailer"
                        :trailerSound="trailerSound"
                        @trailerStarted="istrailerIsEnded = false"
                        @trailerIsEnded="istrailerIsEnded = true"
                        :destoryPlayer="destroyTrailerBg"
                        :poster="
                            movie.posterSmallSrc
                                ? movie.posterSmallSrc
                                : noImageAvailable
                        "
                    />
                </div>
            </div>
            <div class="hero__container container">
                <div class="hero__wrapper">
                    <div class="hero__content">
                        <div class="hero__content__left">
                            <div class="hero__content__imgWrapper">
                                <div
                                    class="hero__img"
                                    @click="playMovieFromCard"
                                    :class="{ isImageLoaded: isImageLoaded }"
                                >
                                    <picture>
                                        <source
                                            media="(max-width: 425px)"
                                            :srcset="movie.posterSmallSrc"
                                        />
                                        <source
                                            media="(min-width: 426px)"
                                            :srcset="movie.posterBigSrc"
                                        />
                                        <img
                                            :src="movie.posterBigSrc"
                                            :alt="movie.name"
                                            draggable="false"
                                            fetchpriority="high"
                                            @load="imageLoaded"
                                        />
                                    </picture>
                                    <!-- <img
                                        :src="movie.posterBigSrc"
                                        draggable="false"
                                        :alt="movie.name"
                                        @load="imageLoaded"
                                        :key="movie.posterBigSrc"
                                        fetchpriority="high"
                                    /> -->
                                    <div
                                        v-if="labels?.providerImg"
                                        class="hero__img_provider"
                                    >
                                        <img
                                            :src="`https://api.tvcom.uz/storage/${labels?.providerImg}`"
                                            alt="Tvcom provider"
                                        />
                                    </div>
                                </div>
                            </div>
                            <h1 class="hero__title">{{ movie.name }}</h1>
                            <ul class="hero__items">
                                <li
                                    class="hero__items_item"
                                    v-if="movie.duration"
                                >
                                    {{ movie.duration }}
                                </li>
                                <li class="hero__items_item" v-if="movie.year">
                                    {{ movie.year }}
                                </li>
                                <li
                                    class="hero__items_item"
                                    v-if="movie.countries"
                                >
                                    {{ onlyTwo(movie.countries) }}
                                </li>
                                <li
                                    class="hero__items_item"
                                    v-if="movie.genres"
                                >
                                    {{ onlyTwo(movie.genres) }}
                                </li>
                                <li
                                    class="hero__items_item hero__items_item--red hero__items_item--age"
                                    v-if="movie.ageRating"
                                >
                                    {{ movie.ageRating }}
                                </li>
                            </ul>
                            <div class="hero__buttons">
                                <template v-if="!needSubscription">
                                    <ElButton
                                        v-if="movie.actionsLength"
                                        size="medium"
                                        type="default"
                                        :attrs="{
                                            'aria-label': $t('message.watch'),
                                            tabindex: 0,
                                            'data-continue-video':
                                                continuePosVideo,
                                            class: 'hero__buttons_btn--watch',
                                        }"
                                        @click="playMovie"
                                    >
                                        <template #icon-left>
                                            <svg
                                                width="20"
                                                height="23"
                                                viewBox="0 0 20 23"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M18.9084 9.8695C20.1205 10.6156 20.1205 12.481 18.9084 13.2271L3.45383 22.7402C2.24171 23.4864 0.726562 22.5537 0.726563 21.0614V2.03515C0.726563 0.542886 2.24171 -0.389778 3.45383 0.356352L18.9084 9.8695Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </template>
                                        {{
                                            isContinue
                                                ? $t("message.continueWatching")
                                                : $t("message.watch")
                                        }}
                                    </ElButton>
                                    <ElButton
                                        size="medium"
                                        type="default"
                                        simple
                                        v-if="movie.actionsLength === 0"
                                    >
                                        {{ $t("message.soon") }}
                                    </ElButton>
                                    <ElButton
                                        size="medium"
                                        type="default"
                                        @click="$router.push('/login')"
                                        v-if="!isLoggedIn"
                                    >
                                        {{ $t("message.neeToLogin") }}
                                    </ElButton>
                                    <ElButton
                                        size="medium"
                                        @click="playTrailer"
                                        :attrs="{
                                            class: 'hero__buttons_btn--trailer',
                                        }"
                                        type="grey"
                                        v-if="movie.trailer"
                                    >
                                        {{ $t("message.trailer") }}
                                    </ElButton>
                                </template>
                                <ElButton
                                    size="medium"
                                    @click="openPaymnetModal"
                                    type="default"
                                    v-if="needSubscription"
                                >
                                    {{ $t("message.watchWithSubscription") }}
                                </ElButton>
                                <!-- <ElButton
                                    size="medium"
                                    @click="openPaymnetModal"
                                    type="default"
                                    v-if="
                                        needSubscription &&
                                        getAlreadyActivateOneSum
                                    "
                                >
                                    <template #icon-left>
                                        <svg
                                            width="20"
                                            height="23"
                                            viewBox="0 0 20 23"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M18.9084 9.8695C20.1205 10.6156 20.1205 12.481 18.9084 13.2271L3.45383 22.7402C2.24171 23.4864 0.726562 22.5537 0.726563 21.0614V2.03515C0.726563 0.542886 2.24171 -0.389778 3.45383 0.356352L18.9084 9.8695Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </template>
                                    <img
                                        class="decor"
                                        src="../../../../assets/assets/paymnetModal/oneSubButtonDecor.png"
                                        alt="TVCOM"
                                    />

                                    {{ $t("message.watchForOneSum") }}
                                </ElButton> -->
                                <ElButton
                                    size="medium"
                                    @click="playTrailer"
                                    :attrs="{
                                        class: 'hero__buttons_btn--trailer',
                                    }"
                                    type="grey"
                                    v-if="movie.trailer && needSubscription"
                                >
                                    {{ $t("message.trailer") }}
                                </ElButton>
                            </div>
                        </div>
                        <div class="hero__content__right">
                            <div class="hero__content__right_wrapper">
                                <div
                                    class="hero__content__right_button hero__content__right_button--ITrailer"
                                    v-if="movie.trailer"
                                    @click="playTrailer"
                                >
                                    <!-- <button
                                        :aria-label="$t('message.trailer')"
                                        class="icon"
                                    >
                                        <ITrailer />
                                    </button> -->
                                    <ElButton
                                        size="medium"
                                        :attrs="{
                                            'aria-label': $t('message.trailer'),
                                        }"
                                        type="grey"
                                        square
                                    >
                                        <template #icon-left>
                                            <ITrailer />
                                        </template>
                                    </ElButton>
                                    <span class="text">{{
                                        $t("message.trailer")
                                    }}</span>
                                </div>
                                <div
                                    class="hero__content__right_button hero__content__right_button--ISound"
                                    v-if="
                                        movie.trailer &&
                                        !istrailerIsEnded &&
                                        !destroyTrailerBg
                                    "
                                    @click="setTrailerSound"
                                >
                                    <!-- <button aria-label="icon" class="icon">
                                        <ISound v-if="!trailerSound" />
                                        <INotSound v-else />
                                    </button> -->
                                    <ElButton
                                        size="medium"
                                        :attrs="{
                                            'aria-label': 'icon',
                                        }"
                                        square
                                        type="grey"
                                    >
                                        <template #icon-left>
                                            <ISound v-if="!trailerSound" />
                                            <INotSound v-else />
                                        </template>
                                    </ElButton>
                                    <span class="text"></span>
                                </div>
                                <div
                                    class="hero__content__right_button hero__content__right_button--IFav"
                                    :class="{
                                        'hero__content__right_button--active':
                                            movie.isFavourite,
                                    }"
                                    @click="favouriteToggle"
                                >
                                    <!-- <button
                                        :aria-label="$t('message.toFavourite')"
                                        class="icon"
                                    >
                                        <IFav />
                                    </button> -->
                                    <ElButton
                                        size="medium"
                                        :attrs="{
                                            'aria-label': 'icon',
                                        }"
                                        square
                                        type="grey"
                                    >
                                        <template #icon-left>
                                            <IFav />
                                        </template>
                                    </ElButton>
                                    <span class="text">{{
                                        $t("message.toFavourite")
                                    }}</span>
                                </div>
                                <div
                                    class="hero__content__right_button hero__content__right_button--IStar"
                                    :class="{
                                        'hero__content__right_button--active':
                                            movie.customer_rating > 0 ||
                                            raitingIsSubmited,
                                    }"
                                    @click="toggleratingOpen"
                                >
                                    <ElButton
                                        size="medium"
                                        :attrs="{
                                            'aria-label': $t('message.goRate'),
                                        }"
                                        square
                                        type="grey"
                                    >
                                        <template #icon-left>
                                            <IStar />
                                        </template>
                                    </ElButton>
                                    <span class="text">{{
                                        $t("message.goRate")
                                    }}</span>
                                </div>
                                <div
                                    class="hero__content__right_button hero__content__right_button--IShare"
                                >
                                    <ElButton
                                        size="medium"
                                        :attrs="{
                                            'aria-label': $t('message.share'),
                                        }"
                                        square
                                        type="grey"
                                    >
                                        <template #icon-left>
                                            <Share
                                                class="movieInner"
                                                dir="top"
                                            />
                                        </template>
                                    </ElButton>
                                    <span class="text">{{
                                        $t("message.share")
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section container" v-if="isWatching">
            <!-- FIXME: починить первый запуск плеера (hlsSource) -->
            <custom-hls-player
                @prev-episode="prevEpisode"
                @next-episode="nextEpisode"
                @save-content-position="saveContentPosition"
                @stat-video-push="statVideoPush"
                @changeQuality="changeQuality"
                @goBack="goBack"
                @toggleSeasonModal="toggleSeasonModal"
                @changeSeason="handleSeasonChange"
                @changeEpisode="changeEpisode"
                @changeQuality_FHD_or_4K="changeQuality_FHD_or_4K"
                @restartMovie="playMovie"
                :hlsSource="hlsSource"
                :videoExtraData="videoExtraData"
                :actionsLength="isSeries ? movie.actionsLength : 1"
                :episodeIds="episodeIds"
                :currentEpisodeIndex="episodeId"
                :current-time-position="
                    isPlayingMovie ? movie.position.time : 0
                "
                :isLoggedIn="isLoggedIn"
                :movieTitle="{
                    title: movie.name,
                    chapter: movie.chapter,
                }"
                :movie="movie"
                :movieType="movie.isSeason"
                :forProblemsInfo="forProblemsInfo"
                :video_provider="movie.provider"
                :video_title="movie.name"
                :showSeasonModal="showSeasonModal"
                :seasons="movie.actions"
                :selectedSeason="selectedSeason"
                :series="movie?.actions[selectedSeason]?.actions"
                :selectedSearia="
                    movie?.seasonIndex === current?.season &&
                    movie?.episodeIndex === current?.episode
                "
                :canNextEpisode="isPlayingTrailer"
                :isSeries="isSeries"
                :currentSeason="current.season"
                :currentEpisode="current.episode"
                :currentCaption="current.caption"
                :movieTitleImg="movie.logo_big"
            />
        </section>
        <section
            class="section seasonSeries"
            v-if="isSeries && isLoadingVideoEpisodeList"
        >
            <div
                class="seasonSeries__container container"
                v-if="movie.actions.length"
            >
                <div class="seasonSeries__navigation">
                    <div class="seasonSeries__navigation_title">
                        {{ $t("message.season") }}
                    </div>
                    <div class="seasonSeries__navigation_nav">
                        <SeasonsSlider
                            :content="movie.actions"
                            :selectedSeason="selectedSeason"
                            @changeSeason="handleSeasonChange"
                        />
                    </div>
                </div>

                <div
                    class="skeleton"
                    v-if="
                        !movie.actions[selectedSeason].actions.length &&
                        !current.totalEpisodes
                    "
                >
                    <div
                        class="skeleton__seriesList"
                        :class="{ listOpen: isListOpened }"
                    >
                        <div class="skeleton__seriesList_item" v-for="i in 6">
                            <div class="skeleton__seriesList_item_imgWrapper">
                                <div
                                    class="skeleton__seriesList_item_imgWrapper_img"
                                ></div>
                            </div>
                            <div class="skeleton__seriesList_item_text"></div>
                        </div>
                    </div>
                </div>
                <seariesList
                    :currentEpisode="current.episode"
                    :currentSeason="current.season"
                    :selectedSeason="selectedSeason"
                    :needSubscription="needSubscription"
                    @changeEpisode="changeEpisode"
                    @setIsListOpened="setIsListOpened"
                    :list="movie.actions[selectedSeason].actions"
                    v-else
                />
            </div>
        </section>
        <section
            class="section seasonSeries"
            v-if="!isSeries && movie.actions?.length >= 2 && !needSubscription"
        >
            <div class="seasonSeries__container container">
                <!-- <div class="seasonSeries__navigation_title">
                    {{ $t("message.videoQuality") }}
                </div> -->
                <div class="skeleton" v-if="!movie.actions">
                    <div
                        class="skeleton__seriesList"
                        :class="{ listOpen: isListOpened }"
                    >
                        <div class="skeleton__seriesList_item" v-for="i in 6">
                            <div class="skeleton__seriesList_item_imgWrapper">
                                <div
                                    class="skeleton__seriesList_item_imgWrapper_img"
                                ></div>
                            </div>
                            <div class="skeleton__seriesList_item_text"></div>
                        </div>
                    </div>
                </div>
                <seariesList
                    :currentEpisode="current.episode"
                    :currentSeason="current.season"
                    :selectedSeason="null"
                    @changeEpisode="changeQuality_FHD_or_4K"
                    @setIsListOpened="setIsListOpened"
                    :list="movie.actions"
                    v-else
                />
                <!-- <ul class="series__list">
                    <li
                        v-for="(item, index) in movie.actions"
                        :key="index"
                        @click="changeQuality_FHD_or_4K(item)"
                        class="series_item"
                        :title="item.caption"
                    >
                        <div
                            class="series_item_poster"
                            :class="{
                                series_item_active:
                                    current.caption === item.caption,
                            }"
                        >
                            <img
                                v-if="item.promo_image_url"
                                :src="item.promo_image_url"
                                alt="Tvcom"
                            />
                            <img
                                v-else
                                src="../../../../assets/assets/serialFace.webp"
                                alt="Tvcom"
                            />
                        </div>

                        <span class="series_item_caption"
                            >{{ item.caption }}
                        </span>
                    </li>
                </ul> -->
            </div>
        </section>
        <section class="section movieInfo">
            <div class="movieInfo__container container">
                <div class="movieInfo__wrapper">
                    <ul class="movieInfo__head">
                        <!-- <li class="movieInfo__head_item">
                            <button
                                :aria-label="$t('message.description')"
                                class="movieInfo__head_item_btn"
                                :class="{
                                    'movieInfo__head_item_btn--active':
                                        isDescOpen || !movie.actors.length,
                                }"
                                @click="toggleIsDescOpened(true)"
                            >
                                {{ $t("message.description") }}
                            </button>
                        </li>
                        <li
                            class="movieInfo__head_item"
                            v-if="movie.actors && movie.actors.length"
                        >
                            <button
                                :aria-label="$t('message.movieCast')"
                                class="movieInfo__head_item_btn"
                                :class="{
                                    'movieInfo__head_item_btn--active':
                                        !isDescOpen,
                                }"
                                @click="toggleIsDescOpened(false)"
                            >
                                {{ $t("message.movieCast") }}
                            </button>
                        </li>
                        <li
                            class="movieInfo__head_item"
                            v-if="movie.actors && movie.actors.length"
                        >
                            <button
                                :aria-label="$t('message.movieCast')"
                                class="movieInfo__head_item_btn"
                                :class="{
                                    'movieInfo__head_item_btn--active':
                                        !isDescOpen,
                                }"
                                @click="toggleIsDescOpened(false)"
                            >
                                Варианты просмотра
                            </button>
                        </li> -->
                        <li
                            class="movieInfo__head_item"
                            v-for="item in moreInfo.list"
                            :key="item.id"
                        >
                            <button
                                :aria-label="$t('message.description')"
                                class="movieInfo__head_item_btn"
                                :class="{
                                    'movieInfo__head_item_btn--active':
                                        item.id === moreInfo.active,
                                }"
                                v-if="item.visibility"
                                @click="toggleMoreInfo(item.id)"
                            >
                                {{ $t(item.name) }}
                            </button>
                        </li>
                    </ul>
                    <div class="movieInfo__content">
                        <div
                            class="movieInfo__content_description"
                            v-if="moreInfo.active === 0"
                        >
                            <div class="movieInfo__content_description_text">
                                <span
                                    v-if="movie.descr"
                                    v-html="movie.descr"
                                    class="movieInfo__content_description_text_content"
                                ></span>
                                <ul class="movieInfo__list">
                                    <li
                                        class="movieInfo__list_item"
                                        v-if="movie.originalName"
                                    >
                                        <p class="movieInfo__list_item_attr">
                                            {{ $t("message.originalName") }}
                                        </p>
                                        <p class="movieInfo__list_item_value">
                                            {{ movie.originalName }}
                                        </p>
                                    </li>
                                    <li
                                        class="movieInfo__list_item"
                                        v-if="movie.director"
                                    >
                                        <p class="movieInfo__list_item_attr">
                                            {{ $t("message.director") }}
                                        </p>
                                        <p class="movieInfo__list_item_value">
                                            {{ movie.director }}
                                        </p>
                                    </li>
                                    <li
                                        class="movieInfo__list_item"
                                        v-if="
                                            movie.genres &&
                                            movie.genres.split(',').length > 1
                                        "
                                    >
                                        <p class="movieInfo__list_item_attr">
                                            {{ $t("message.filter.genre") }}
                                        </p>
                                        <p class="movieInfo__list_item_value">
                                            {{ movie.genres }}
                                        </p>
                                    </li>
                                    <li
                                        class="movieInfo__list_item"
                                        v-if="
                                            movie.countries &&
                                            movie.countries.split(',').length >
                                                1
                                        "
                                    >
                                        <p class="movieInfo__list_item_attr">
                                            {{ $t("message.country") }}
                                        </p>
                                        <p class="movieInfo__list_item_value">
                                            {{ movie.countries }}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                            <div class="movieInfo__content_description_rate">
                                <ul
                                    class="hero__ratings"
                                    v-if="
                                        movie?.rating.kinopoisk ||
                                        movie?.average_customers_rating > 0 ||
                                        movie?.rating?.imdb
                                    "
                                >
                                    <li
                                        class="hero__ratings_item"
                                        v-if="movie?.rating?.kinopoisk"
                                    >
                                        <div class="hero__ratings_item_img">
                                            <img
                                                src="../../../../assets/assets/Kinopoisk.svg"
                                                alt="Tvcom"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div class="hero__ratings_item_number">
                                            {{ movie?.rating?.kinopoisk }}
                                        </div>
                                    </li>
                                    <li
                                        class="hero__ratings_item"
                                        v-if="movie?.rating?.imdb"
                                    >
                                        <div class="hero__ratings_item_img">
                                            <img
                                                src="../../../../assets/assets/IMDB.svg"
                                                alt="Tvcom"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div class="hero__ratings_item_number">
                                            {{ movie?.rating?.imdb }}
                                        </div>
                                    </li>
                                    <li
                                        class="hero__ratings_item"
                                        v-if="
                                            movie?.average_customers_rating > 0
                                        "
                                    >
                                        <div class="hero__ratings_item_img">
                                            <img
                                                src="../../../../assets/assets/TVCOM_RATING.svg"
                                                alt="Tvcom"
                                                loading="lazy"
                                            />
                                        </div>
                                        <div class="hero__ratings_item_number">
                                            {{
                                                movie?.average_customers_rating
                                            }}
                                        </div>
                                    </li>
                                </ul>
                                <MovieRating
                                    :customer_rating="movie.customer_rating"
                                    :movie="movie"
                                    :class="ratingIsOpen ? 'open' : ''"
                                    :isLoggedIn="isLoggedIn"
                                    @toggleRatingOpen="toggleratingOpen"
                                    @openAuth="openAuth"
                                    @submitedRating="submitedRating"
                                />
                            </div>
                        </div>
                        <div
                            class="movieInfo__content_actors"
                            v-if="moreInfo.active === 1"
                        >
                            <ul class="actors_list" ref="actorsList">
                                <router-link
                                    :to="{
                                        name: 'personFilms',
                                        params: { provider: actor.id },
                                    }"
                                    class="actor_item"
                                    v-for="actor in movie.actors"
                                    :class="{
                                        director: actor.type === 'Director',
                                    }"
                                    :key="actor.id"
                                >
                                    <img
                                        v-if="actor.photo"
                                        :src="
                                            actor.photo ||
                                            '../../../../assets/icons/actorStockImg.svg'
                                        "
                                        :alt="`actor ${actor.name}`"
                                    />

                                    <img
                                        v-else
                                        src="../../../../assets/icons/actorStockImg.svg"
                                        :alt="`actor ${actor.name}`"
                                        class="actor_stock_img"
                                    />

                                    <div class="actor_item_name">
                                        <h3>
                                            {{ actor.name }}
                                        </h3>
                                        <!-- <IDirector v-if="actor.type === 'Director'" /> -->
                                    </div>
                                    <span v-if="actor.type === 'Director'">
                                        {{ $t("message.director") }}
                                    </span>
                                </router-link>
                            </ul>
                        </div>
                        <div
                            class="movieInfo__content_tarrifList"
                            v-if="moreInfo.active === 2"
                        >
                            <template v-if="currentTarriList.length > 0">
                                <TariffCard
                                    v-for="item in currentTarriList"
                                    :key="item.id"
                                    :item="item"
                                    :id="item.name"
                                    :pressBuyTariff="pressBuyTariff"
                                    :class="{
                                        active: $route.hash == item.name,
                                    }"
                                />
                            </template>
                            <TariffListLoader
                                v-else
                                v-for="item in 3"
                                :key="item"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="similar_movie_section container container-fluid"
            v-if="similarMovies"
        >
            <similarVideos
                :content="similarMovies"
                :title="$t(`message.similar`)"
            />
        </section>
    </main>
    <PaymentModal
        :type="getModalTypes[getIsPaymentModalActiveType]"
        v-if="isLoggedIn"
        @paymnetSuccess="paymnetSuccess"
    />
    <div
        class="unAuthorizeModal"
        :class="{ open: isModalAuthOpen }"
        @click="toggleModalAuth"
    >
        <div class="unAuthorizeModal__wrapper" @click.stop>
            <div class="text">{{ $t("message.goToAuth") }}</div>
            <div class="btns">
                <!-- <button class="btn" @click="toggleModalAuth">
                    {{ $t("message.cancel") }}
                </button> -->
                <ElButton
                    :size="windowWidth < 576 ? 'small' : 'medium'"
                    type="grey"
                    @click="toggleModalAuth"
                >
                    {{ $t("message.cancel") }}
                </ElButton>
                <ElButton
                    :size="windowWidth < 576 ? 'small' : 'medium'"
                    type="default"
                    @click="$router.push('/login')"
                >
                    {{ $t("message.neeToLogin") }}
                </ElButton>
                <!-- <button class="btn auth" @click="$router.push('/login')">
                    {{ $t("message.neeToLogin") }}
                </button> -->
            </div>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import noImageAvailable from "../../../../assets/assets/noImageAvailable.webp";
const Share = defineAsyncComponent(() =>
    import("../../../components/Share.vue")
);
const TariffCard = defineAsyncComponent(() =>
    import("../../../components/TariffCard.vue")
);

const SeasonsSlider = defineAsyncComponent(() =>
    import("../../../components/SeasonsSlider.vue")
);
const CustomHlsPlayer = defineAsyncComponent(() =>
    import("../../../components/video-player/CustomHlsPlayer.vue")
);
const similarVideos = defineAsyncComponent(() =>
    import("../../../components/similarVideos.vue")
);

const PaymentModal = defineAsyncComponent(() =>
    import("../../../components/paymentModal/index.vue")
);
const MovieRating = defineAsyncComponent(() =>
    import("../../../components/movieRaiting/index.vue")
);
const TariffListLoader = defineAsyncComponent(() =>
    import("../../../components/Loaders/TariffListLoader.vue")
);
const seariesList = defineAsyncComponent(() =>
    import("../../../components/movie/seriesList.vue")
);
import { WORD_NOT_VISIBLE_DETAIL_PAGE } from "../../../constants/movie_constants";
import PlayTrailerBg from "../../../components/video-player/PlayTrailerBg.vue";
import {
    IFav,
    IShare,
    ITrailer,
    IStar,
    ISound,
    INotSound,
} from "../../../components/movie/icons";

import {
    getMovieUrl,
    getVideoDetail,
    fetchSearchSimilar,
    addViewed,
    getVideoDetailNoAuth,
    subscriptionList,
    likeMovie,
    getVideoEpisodeList,
    fetchCustomerTariffList,
} from "../../../Api";

import VIDEO_STATS_API from "../../../Api/VideoStats";
import ElButton from "../../../components/ElButton";
import { mapGetters } from "vuex";
export default {
    name: "MoviePage",
    props: ["id"],
    components: {
        CustomHlsPlayer,
        similarVideos,
        SeasonsSlider,
        PaymentModal,
        Share,
        seariesList,
        PlayTrailerBg,
        MovieRating,
        IFav,
        IShare,
        ITrailer,
        IStar,
        ISound,
        INotSound,
        ElButton,
        TariffCard,
        TariffListLoader,
    },

    data: () => ({
        showModal: false,
        isLoggedIn: false,
        showSeasonModal: false,
        actorsListIsOpen: false,
        raitingIsSubmited: false,
        // user
        // abonentSubscriptions: {},
        needSubscription: false,
        availableSubscriptions: [],
        noImageAvailable: noImageAvailable,
        currentTarriList: [],
        windowWidth: window.innerWidth,
        ratingIsOpen: false,
        // movie
        isLoadingMovie: true,
        isSeries: false,
        isListOpened: false,
        cinema_back_bg_class: "",
        videoExtraData: {},
        isLoadingVideoEpisodeList: true,
        istrailerIsEnded: true,
        destroyTrailerBg: false,
        movie: {
            isFavourite: 0,
            isSeason: false,
            provider: "",
            provider_id: 0,
            posterBigSrc: "",
            posterSmallSrc: "",
            name: "",
            originalName: "",
            descr: "",
            year: 0,
            countries: "",
            genres: "",
            duration: 0,
            ageRating: 0,
            rating: {
                kinopoisk: 0,
                imdb: 0,
            },
            provider_id: 0,
            customer_rating: 0,
            average_customers_rating: 0,
            about: [],
            actors: [],
            chapter: "",
            trailer: {},
            allEpisodes: [],
            actions: [],
            actionsLength: 0,
            position: {
                time: 0,
                assetId: 0,
                seasonId: 0,
            },
        },
        freeActions: [],
        forProblemsInfo: {
            movie_id: 0,
            movie_title: "",
            episode_title: "",
            problem_id: 0,
            video_url: "",
            channel_id: 0,
            channel_title: "",
            program_id: 0,
            program_title: "",
        },
        similarMovies: [],
        allActions: [],
        // HLS
        hlsSource: "",
        trailerSrc: "",
        continuePosVideoAction: {},
        continuePosVideo: "", // Сезон 1 Серия 2 \ 34:55
        isContinue: false,

        selectedSeason: 0,
        episodeId: 0,

        current: {
            season: 0,
            episode: 0,
            action: {},
            totalEpisodes: 0,
            caption: null,
        },
        episodeIds: {
            currentMovieId: null,
            firstMovieId: null,
            lastMovieId: null,
        },
        isPlayingMovie: false,
        isPlayingTrailer: false,
        showMoreTextButton: false,
        isClipBoard: false,
        windowInnerWidth: null,
        isActorsFull: false,
        isDescOpen: true,
        trailerSound: true,
        isModalAuthOpen: false,
        isImageLoaded: false,
        moreInfo: {
            active: 0,
            list: [
                {
                    id: 0,
                    name: "message.description",
                    visibility: true,
                },
                {
                    id: 1,
                    name: "message.movieCast",
                    visibility: true,
                },
                {
                    id: 2,
                    name: "message.viewOptions",
                    visibility: true,
                },
            ],
        },
    }),

    computed: {
        locale() {
            return this.$i18n.locale;
        },
        isWatching() {
            return this.$route.query.watch === "true";
        },

        ...mapGetters([
            "getIsPaymentModalActiveType",
            "getModalTypes",
            "getMyAllTarrifs",
            "getProviders",
            "getAlreadyActivateOneSum",
        ]),
        providers() {
            return this.getProviders.reduce((acc, el) => {
                if (!acc[el.provider_id]) acc[el.provider_id] = el;
                return acc;
            }, {});
        },

        labels() {
            const item = this.movie;

            const providerImg = this.providers[item.provider_id]?.img;
            return {
                providerImg,
            };
        },
    },

    created() {
        this.verifyAccess();
        this.isListOpened = localStorage.getItem("seriesList") === "true";
    },

    mounted() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        this.$nextTick(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        });

        setTimeout(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        }, 300);
        // window.addEventListener("resize", this.isDescFulled);
        const query = { ...this.$route.query };
        delete query.watch;
        this.$router.push({ query });
        window.addEventListener("resize", this.windowResize);
    },

    beforeUnmount() {
        window.removeEventListener("beforeunload", this.resetScroll);
        // window.removeEventListener("resize", this.isDescFulled);
        if (document.pictureInPictureElement) {
            document.exitPictureInPicture();
        }
        this.$store.commit("setIsPaymentModalActiveType", "");
        this.$store.commit("setIsPaymentModalActive", false);

        this.checkShowModal();
        this.removeWatchQuery();
        window.removeEventListener("resize", this.windowResize);
    },

    beforeRouteLeave: function (to, from, next) {
        next();
    },

    watch: {
        id(value) {
            window.onbeforeunload = this.resetScroll();
            this.isImageLoaded = false;

            this.isSeries = false;
            this.isContinue = false;
            this.isPlayingMovie = false;
            this.isPlayingTrailer = false;
            this.continuePosVideo = "";
            this.actorsListIsOpen = false;
            this.selectedSeason = 0;
            this.episodeId = 0;
            this.$nextTick(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                });
            });
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                });
            }, 300);
            this.current = {
                season: 0,
                episode: 0,
                action: {},
            };

            this.verifyAccess();
        },
        "current.episode": {
            handler(value) {
                if (value) {
                    this.editTheEpisodIfo(this.current.season, value);
                }
            },
        },
        async locale() {
            const response = await getVideoDetail(this.id, this.checkLang());
            this.movie.descr = response.description;
            this.movie.name = response.name;
            this.movie.originalName = response.name_orig;
            this.movie.countries = response.countries;
            this.movie.genres = this.janresFormatter(response?.genres);
            this.movie.actors = this.getFilteredActors(response?.actors_info);
            // this.movie.actions = this.formatActions(response);
        },

        showModal(value) {
            this.checkShowModal(value);
        },
        isWatching(value) {
            if (value) {
                document.body.className = "hidden";
                if (!this.destroyTrailerBg) {
                    this.destroyTrailerBg = true;
                }
            } else {
                document.body.className = "auto";
            }
        },
        $route(value) {
            if (value.query.watch === "true") {
                this.watchMovie();
            } else {
                this.isPlayingMovie = false;
                this.isPlayingTrailer = false;
            }
        },
    },

    methods: {
        async sortTarrifs(actions) {
            this.$store.commit("setAvailableSubscriptions", actions);
            const middleResponse = await fetchCustomerTariffList();
            const tarrifs = this.getMyAllTarrifs.reduce((acc, item) => {
                if (item.tariffs) {
                    return acc.concat(item.tariffs);
                }
                return acc;
            }, []);
            const moreOptions = tarrifs.map((item) => {
                return {
                    ...item,
                    price: parseInt(
                        middleResponse.find(
                            (tariff) => tariff.id === item.tariff_id
                        )?.price
                    ),
                    price_after_activation: parseInt(
                        middleResponse.find(
                            (tariff) => tariff.id === item.tariff_id
                        )?.price_after_activation
                    ),
                };
            });
            if (!actions?.length) {
                return [];
            }
            const subscriptions = await subscriptionList();
            const doubleMore = this.getMayTArrifs(moreOptions, subscriptions);
            const ids = actions.map(
                (item) => item.subscription_id || item.tariff_id
            );
            if (this.type === "movie") {
            }
            const list = doubleMore.filter((item) =>
                ids.includes(item.tariff_id)
            );

            this.$store.commit("setAvailableSubscriptions", actions);
            this.currentTarriList = list;
        },
        getMayTArrifs(interlayerResponse, subscriptions) {
            const userSubscriptions = Array.isArray(subscriptions)
                ? subscriptions
                : [subscriptions];

            const tempTariffCopy = JSON.parse(
                JSON.stringify(interlayerResponse)
            );

            for (let index = 0; index < tempTariffCopy.length; index++) {
                const tarProsloyka = tempTariffCopy[index];
                if (userSubscriptions.length) {
                    for (let idx = 0; idx < userSubscriptions.length; idx++) {
                        const tarUser = userSubscriptions[idx];
                        if (tarUser.tariff_id === tarProsloyka.tariff_id) {
                            tarProsloyka.is_periodical = tarUser.is_periodical;
                            tarProsloyka.subscription_end_date =
                                tarUser.end_date;
                            tarProsloyka.is_assigned = 1;
                            tarProsloyka.start_date = tarUser.start_date;
                            tarProsloyka.period = 30;
                        }
                    }
                }

                for (let j = 0; j < tarProsloyka.sub_tariffs.length; j++) {
                    const subTarifProsloyka = tarProsloyka.sub_tariffs[j];
                    for (let k = 0; k < userSubscriptions.length; k++) {
                        const userTarriff = userSubscriptions[k];

                        if (
                            userTarriff.tariff_id ===
                            subTarifProsloyka.remote_tariff_id
                        ) {
                            tarProsloyka.is_periodical =
                                userTarriff.is_periodical;
                            const string =
                                subTarifProsloyka.period_ru.match(/\d+/);
                            const days = string ? Number(string[0]) : 30;
                            tarProsloyka.is_assigned = 1;

                            tarProsloyka.price = userTarriff.price;
                            tarProsloyka.start_date = userTarriff.start_date;
                            tarProsloyka.end_date = userTarriff.end_date;
                            tarProsloyka.period = 30000;
                            tarProsloyka.tariff_id = userTarriff.tariff_id;
                            tarProsloyka.subscription_end_date =
                                userTarriff.end_date;

                            break;
                        }
                    }
                }
            }

            const newPrice = tempTariffCopy.map((item) => {
                if (item.sub_tariffs.length) {
                    item.sub_tariffs = item.sub_tariffs.map((sub) => {
                        if (sub.remote_tariff_id === item.tariff_id) {
                            sub.price = item.price;
                        }
                        return sub;
                    });
                }
                return item;
            });

            return tempTariffCopy;
        },
        playMovieFromCard() {
            if (this.windowWidth <= 992) {
                if (this.isLoggedIn) {
                    if (!this.needSubscription) {
                        this.playMovie();
                    } else {
                        this.openPaymnetModal();
                    }
                } else {
                    this.$router.push("/login");
                }
            }
        },
        async getUserInfo() {
            this.$store.dispatch("getUserInfo");
        },
        openAuth() {
            this.isModalAuthOpen = true;
        },
        pressBuyTariff(item) {
            this.$store.commit("setIsPaymentModalActiveType", "cabinet");
            this.$store.commit("setIsPaymentModalActive", true);
            this.$store.commit("setCurrentTarrif", item);
        },
        toggleModalAuth() {
            this.isModalAuthOpen = !this.isModalAuthOpen;
        },
        imageLoaded() {
            this.isImageLoaded = true;
        },
        toggleratingOpen() {
            if (!this.isLoggedIn) {
                this.openAuth();
                return;
            }
            this.ratingIsOpen = !this.ratingIsOpen;
        },
        setIsListOpened(value) {
            this.isListOpened = value;
            localStorage.setItem("seriesList", value);
        },
        windowResize() {
            this.windowWidth = window.innerWidth;
        },
        watchActorsList() {
            const grid = this.$refs.actorsList;
            if (!grid || !this.movie || !this.movie.actors?.length) {
                this.isActorsFull = false;
                return;
            }

            const containerWidth = grid.offsetWidth;
            const itemMinWidth = 280;
            const gap = 18;
            const itemsPerRow = Math.floor(
                (containerWidth + gap) / (itemMinWidth + gap)
            );

            const threeColumnThreshold = itemsPerRow * 3;
            this.isActorsFull = this.movie.actors.length < threeColumnThreshold;
        },
        toggleIsDescOpened(value) {
            this.isDescOpen = value;
        },
        toggleMoreInfo(value) {
            this.moreInfo.active = value;
        },
        handleActorList() {
            this.actorsListIsOpen = !this.actorsListIsOpen;
        },
        replaceSpaces(value) {
            return value
                .replace(/Кинотеатр/g, "")
                .replace(/[\s-]/g, "")
                .toLowerCase();
        },
        toggleSeasonModal() {
            this.showSeasonModal = !this.showSeasonModal;
            this.selectedSeason = this.current.season;
        },
        goBack(currentTime) {
            this.$router.go(-1);
            this.isPlayingMovie = false;
            this.isPlayingTrailer = false;
            this.saveContentPosition(currentTime);
        },
        removeWatchQuery() {
            const query = { ...this.$route.query };
            if (query.watch === "true") {
                delete query.watch;
                this.$router.push({ query });
            }
        },
        addWatchQuery() {
            if (!this.$route.query.watch) {
                this.$router.push({
                    query: { watch: true },
                });
            }
        },
        checkShowModal(value) {
            if (value) {
                document.body.className = "hidden";
                return;
            }

            document.body.className = "auto";
        },
        setTrailerSound() {
            this.trailerSound = !this.trailerSound;
        },
        verifyAccess() {
            if (
                localStorage.getItem("access") === "true" &&
                localStorage.getItem("token")
            ) {
                this.isLoggedIn = true;
                // this.getSubscriptionList();
                this.loadMovieAuth(this.id);
                this.getUserInfo();
            } else {
                this.isLoggedIn = false;
                localStorage.setItem("access", false);
                this.loadMovieNoAuth(this.id);
                this.moreInfo.list[2].visibility = false;
            }
        },
        paymnetSuccess() {
            this.verifyAccess();
            this.$store.commit("setClaearmOVIES");
        },
        editTheEpisodIfo(season, episod) {
            if (this.movie.isSeason) {
                const infoEpisodCaption =
                    this.movie.actions[season].actions[episod];
                this.forProblemsInfo.episode_title = infoEpisodCaption.caption;
            } else {
                this.forProblemsInfo.episode_title = "";
            }
        },
        // isDescFulled() {
        //     this.watchActorsList();
        //     this.windowInnerWidth = window.innerWidth;
        //     const description = this.$refs.movieDescrRef;
        //     const descText = description.querySelector("span");
        //     if (descText.offsetHeight > description.offsetHeight) {
        //         this.showMoreTextButton = true;
        //     } else {
        //         this.showMoreTextButton = false;
        //     }
        // },
        onlyTwo(arr) {
            return arr.split(",").slice(0, 1).join(", ");
        },
        submitedRating() {
            this.raitingIsSubmited = true;
        },
        async loadMovieAuth(id, loading = true) {
            try {
                this.isLoadingMovie = loading;
                const response = await getVideoDetail(id, this.checkLang());
                if (!response || response.error) {
                    this.$router.push({ name: "404" });
                    return;
                }

                document.title = this.appendTitleMovie(response);

                this.movie = {
                    isFavourite: !!response.is_favorited,
                    isSeason: !!response.is_season,
                    provider:
                        this.getProvider(response?.video_provider_id) || 3,
                    provider_id: response?.video_provider_id,
                    posterBigSrc: response?.thumbnail_big || noImageAvailable,
                    posterSmallSrc:
                        response?.thumbnail_small || noImageAvailable,
                    name: response?.name || "Без названия",
                    customer_rating: response?.customer_rating,
                    average_customers_rating: this.ratingFormatter(
                        response?.average_customers_rating
                    ),
                    originalName: response?.name_orig, //
                    descr: response?.description,
                    duration: this.timeConverter(response?.duration || 0),
                    year: response?.year,
                    countries: response.countries,
                    genres: this.janresFormatter(response?.genres || []),
                    ageRating:
                        response?.rating >= 0 ? response?.rating + "+" : 0,
                    director: response?.director,
                    actors: Array.isArray(response?.actors_info)
                        ? this.getFilteredActors(response.actors_info)
                        : [],
                };
                // this.loadLayzyImage(response?.thumbnail_big);
                this.allActions = Array.isArray(response.actions)
                    ? response.actions
                    : [];
                this.forProblemsInfo = {
                    movie_id: response?.id,
                    movie_title: response?.name,
                    episode_title: "",
                    video_url: "",
                    channel_id: response?.channel_id,
                    channel_title: response?.channel_name,
                    program_id: response?.program_id,
                    program_title: response?.program_name,
                };

                this.movie.rating = {
                    kinopoisk: this.ratingFormatter(response?.kinopoisk_rating),
                    imdb: this.ratingFormatter(response?.imdb_rating),
                };

                this.movie.about = this.formatAboutMovie(this.movie);
                this.cinema_back_bg_class = this.getCinemaBg(
                    this.movie.provider
                );

                this.movie.actions = this.formatActions(response);

                this.movie.position = this.getAboutMoviePosition(response);
                this.movie.logo_big = response?.logo_big;
                // this.setActionCaotion(response);
                // this.$nextTick(() => {
                //     this.isDescFulled();
                // });
                if (this.movie.actors.length == 0) {
                    this.moreInfo.list[1].visibility = false;
                }
                if (loading) {
                    await this.getSimilarMovie();
                }
            } catch (error) {
                console.error("Ошибка загрузки фильма:", error);
                this.$router.push({ name: "404" });
            } finally {
                this.isLoadingMovie = false;
            }
        },
        appendTitleMovie(movie) {
            const movieGenres = Array.isArray(movie.genres)
                ? movie.genres
                : movie.genres.split(",").map((g) => g.trim());
            const movieLanguage = movie.language || "";
            const movieLangList = ["O'zbek", "Uzbek"];

            const isUzb =
                movieGenres.includes("Узбекский") ||
                movieLangList.includes(movieLanguage);
            const isSerial = Boolean(movie.is_season);
            const seasons = this.getSeasonRange(movie.seasons || [], isUzb);

            const isAnime = movieGenres
                .map((g) => g.toLowerCase())
                .includes("аниме");
            const isCartoon = movieGenres.some((g) =>
                ["Мультфильм", "Мультсериалы"].includes(g)
            );

            const isSerialText = isSerial ? " сериал " : " фильм ";
            const isSerialTextUz = isSerial ? " serialni " : " kinoni ";

            const notSupportGenresList = [
                "русский",
                "Русский",
                "аниме",
                "мультфильм",
                "мультсериалы",
                "4k",
                "сериалы",
                "зарубежные",
                "фильм",
                "Фильм",
                "Зарубежные",
            ];

            const ending = "описание, актёры в хорошем качестве";
            const endingUz = "tavsifi, aktyorlar, yuqori sifatda, uzbek tilida";

            const genre = this.getGenre(movie, notSupportGenresList);

            if (!isUzb) {
                if (isAnime) {
                    return `Смотреть${isSerialText} ${movie.name} (аниме) ${movie.year}, ${seasons} ${ending}`;
                }
                if (isCartoon) {
                    return `Смотреть мультфильм ${movie.name} ${movie.year}, ${seasons} ${ending}`;
                }
                if (isSerial) {
                    return `Смотреть сериал ${movie.name} (${genre}), ${movie.year}, ${seasons} ${ending}`;
                }
                return `Смотреть фильм ${movie.name} (${genre}), ${movie.year}, ${ending}`;
            } else {
                if (isAnime) {
                    return `${movie.name}${isSerialTextUz} ko‘rish (anime) ${movie.year}, ${seasons} ${endingUz}`;
                }
                if (isCartoon) {
                    return `${movie.name} multfilmni ko‘rish ${movie.year}, ${seasons} ${endingUz}`;
                }
                if (isSerial) {
                    return `${movie.name} serialni ko‘rish (${genre}), ${movie.year}, ${seasons} ${endingUz}`;
                }
                return `${movie.name} kinoni ko‘rish (${genre}), ${movie.year}, ${endingUz}`;
            }
        },

        getSeasonRange(files, isUzb) {
            const seasonNumbers = files
                .map((file) => {
                    const match = file.name.match(/Сезон (\d+)/u);
                    return match ? parseInt(match[1], 10) : null;
                })
                .filter(Boolean);

            if (!seasonNumbers.length) return "";

            const minSeason = Math.min(...seasonNumbers);
            const maxSeason = Math.max(...seasonNumbers);

            return isUzb
                ? minSeason === maxSeason
                    ? `${minSeason} mavsum, barcha qismlar,`
                    : `${minSeason}-${maxSeason} mavsum, barcha qismlar,`
                : minSeason === maxSeason
                ? `${minSeason} сезон, все серии,`
                : `${minSeason}-${maxSeason} сезон, все серии,`;
        },

        getGenre(movie, notSupportGenresList) {
            const filterGenres = (genres) =>
                genres
                    .split(",")
                    .map((g) => g.trim())
                    .filter((g) => !notSupportGenresList.includes(g));

            let genres = filterGenres(movie.genres || "");
            if (genres.length) return genres[0];

            let kinopoiskGenres = filterGenres(movie.genres_kinopoisk || "");
            return kinopoiskGenres.length ? kinopoiskGenres[0] : "";
        },

        checkLang() {
            return this.$i18n.locale === "uz" ? "fr" : "ru";
        },

        openPaymnetModal() {
            this.$store.commit("setIsPaymentModalActiveType", "movie");
            this.$store.commit("setIsPaymentModalActive", true);
        },
        async loadMovieNoAuth(id) {
            try {
                this.isLoadingMovie = true;

                const response = await getVideoDetailNoAuth(id);

                if (!response || response.error) {
                    this.$router.push({ name: "404" });
                    return;
                }

                this.movie = {
                    provider:
                        this.getProvider(response?.video_provider_id) || 3,
                    provider_id: response?.video_provider_id,
                    posterBigSrc: response?.thumbnail_big,
                    posterSmallSrc: response?.thumbnail_small,
                    average_customers_rating: this.ratingFormatter(
                        response?.average_customers_rating
                    ),
                    customer_rating: response?.customer_rating,
                    name: response?.name,
                    originalName: response?.name_orig, //
                    descr: response?.description,
                    duration: this.timeConverter(response?.duration || 0),
                    year: response?.year,
                    countries: response?.countries,
                    genres: this.janresFormatter(response?.genres || []),
                    ageRating: response?.rating + "+",
                    director: response?.director,
                    actors: Array.isArray(response?.actors_info)
                        ? this.getFilteredActors(response.actors_info)
                        : [],
                };
                // this.loadLayzyImage(response?.thumbnail_big);
                this.allActions = Array.isArray(response.actions)
                    ? response.actions
                    : [];
                this.movie.rating = {
                    kinopoisk: this.ratingFormatter(response?.kinopoisk_rating),
                    imdb: this.ratingFormatter(response?.imdb_rating),
                };

                this.movie.about = this.formatAboutMovie(this.movie);

                this.cinema_back_bg_class = this.getCinemaBg(
                    this.movie.provider
                );
                document.title = this.appendTitleMovie(response);

                this.getSimilarMovie();
            } catch (error) {
                console.error("Ошибка загрузки фильма (NoAuth):", error);
                this.$router.push({ name: "404" }); // Можно сделать редирект на страницу ошибки
            } finally {
                this.isLoadingMovie = false;
            }
        },

        loadLayzyImage(image) {
            const img = new Image();
            img.src = image;
            img.onload = () => {
                this.movie.posterBigSrc = image;
            };
        },

        // async getSubscriptionList() {
        //     const subscriptions = await subscriptionList();

        //     const tariffList = {
        //         32: {
        //             id: 32,
        //             name: "amediateka",
        //         },
        //         35: {
        //             id: 35,
        //             name: "megogo",
        //         },
        //         39: {
        //             id: 39,
        //             name: "start",
        //         },
        //         51: {
        //             id: 51,
        //             name: "moretv",
        //         },
        //         62: {
        //             id: 62,
        //             name: "premier",
        //         },
        //     };

        //     const abonSubscr = subscriptions.reduce((acc, el) => {
        //         const tariff = tariffList[el.tariff_id];

        //         if (tariff?.id) acc[tariff.id] = tariff;

        //         return acc;
        //     }, {});

        //     this.abonentSubscriptions = abonSubscr;
        // },

        checkSubscriptions(actions) {
            const needSubscription = actions.some((el) =>
                el.action.match(/(buy_in_subscription|subscribe)/i)
            );

            this.needSubscription = needSubscription;
            this.availableSubscriptions = actions
                .filter((item) => {
                    return item.action !== "get_trailer_url";
                })
                .map((el) => ({
                    ...el,
                    caption: el.caption.replace(/купить в подписке /i, ""),
                }));

            if (!this.needSubscription) {
                this.moreInfo.list[2].visibility = false;
            }
            this.sortTarrifs(this.availableSubscriptions);
            return needSubscription;
        },
        async sortAllTArrifs() {
            let response = [];
            if (!this.getMyAllTarrifs) {
                response = await GetAllTarrifs();
            } else {
                response = this.getMyAllTarrifs;
            }

            const result = response.flatMap((item) =>
                item.tariffs.map((tariff) => ({
                    ...tariff,
                    category: {
                        id: item.id,
                        name: item.name,
                    },
                }))
            );
            return result;
        },
        async setAvalableSubscriptions(actions) {
            const middleResponse = await fetchCustomerTariffList(); // Список тарифов из мидлы
            const interlayerResponse = await this.sortAllTArrifs(); // Список тарифов из прослойки
            const moreOptions = interlayerResponse.map((item) => {
                return {
                    ...item,
                    price: parseInt(
                        middleResponse.find(
                            (tariff) => tariff.id === item.tariff_id
                        )?.price
                    ),
                    price_after_activation: parseInt(
                        middleResponse.find(
                            (tariff) => tariff.id === item.tariff_id
                        )?.price_after_activation
                    ),
                };
            });
            const ids = actions.map(
                (item) => item.subscription_id || item.tariff_id
            );

            this.$store.commit("setAvailableSubscriptions", actions);
        },
        formatActions(movie) {
            try {
                const { is_season, seasons, actions } = movie;
                this.checkSubscriptions(actions);

                if (!Array.isArray(actions) || actions.length === 0) {
                    this.continuePosVideo = this.$t(
                        "message.cotentAvailableSoon"
                    );
                    this.movie.actionsLength = 0;
                    return [];
                }

                const setTrailer = (actionsList) => {
                    // const firstAction = actionsList[0];
                    // const captionLower =
                    //     firstAction.caption?.toLowerCase() || "";
                    const trailer = actionsList.find(
                        (el) =>
                            el.action === "get_trailer_url" &&
                            el.episode_id === "0"
                    );
                    const freeActions = actionsList.filter(
                        (el) =>
                            el.action === "get_trailer_url" &&
                            el.episode_id !== "0"
                    );
                    if (freeActions.length) {
                        if (this.needSubscription) {
                            this.freeActions = freeActions;
                        } else {
                            this.freeActions = [];
                        }
                    }
                    if (trailer) {
                        this.movie.trailer = trailer;
                        const actionss = actionsList.filter(
                            (el) => el.file_id !== trailer.file_id
                        );
                        this.movie.actionsLength = actionss.length;
                        return actionss;
                    }

                    this.movie.actionsLength = actionsList.length;
                    return actionsList;
                };

                const filteredActions = setTrailer(actions);

                if (is_season && seasons.length === 0) {
                    return this.formatSeasons(filteredActions);
                }
                if (seasons.length) {
                    return this.formatSeasonsV2(seasons);
                }

                // this.movie.actionsLength =
                //     filteredActions.length > 1 ? filteredActions.length : 0;

                this.movie.allEpisodes = [filteredActions];
                return filteredActions;
            } catch (error) {
                console.error("Ошибка форматирования действий:", error);
                return [];
            }
        },
        // FIXME: написать производительную сортировку
        formatSeasons(actions) {
            const sortedActions = actions.sort(
                (a, b) =>
                    (+a.caption.split(" ")[1] || 1) -
                    (+b.caption.split(" ")[1] || 1)
            );

            this.isSeries = true;

            let seasonIndex = -1;
            let episodeIndex = -1;
            let totalEpisodes = 0;
            const allEpisodes = [];

            const formattedActionsObj = sortedActions.reduce((acc, el, i) => {
                const season = +el.caption.match(/(сезон) (\d{1,})/i)?.[2] || 1;

                const episode =
                    +el.caption.match(/(серия) (\d{1,})/i)?.[2] ||
                    el.caption.match(/\d+\s(.+)/)?.[1] ||
                    el.caption;

                if (season) {
                    totalEpisodes += 1;
                    episodeIndex += 1;

                    const episodeItem = {
                        ...el,
                        season,
                        episode,
                        id: i + 1,
                    };

                    const key_season = `season_${season}`;

                    if (!acc[key_season]) {
                        totalEpisodes = 1;
                        seasonIndex += 1;
                        episodeIndex = 0;

                        const seasonItem = {
                            seasonIndex,
                            season,
                            totalEpisodes,
                            actions: [
                                { ...episodeItem, episodeIndex, seasonIndex },
                            ],
                        };

                        acc[key_season] = seasonItem;

                        allEpisodes.push({
                            ...episodeItem,
                            seasonIndex,
                            episodeIndex,
                        });
                    } else {
                        acc[key_season].actions.push({
                            ...episodeItem,
                            seasonIndex,
                            episodeIndex,
                        });
                        acc[key_season].totalEpisodes = totalEpisodes;
                        allEpisodes.push({
                            ...episodeItem,
                            seasonIndex,
                            episodeIndex,
                        });
                    }
                }

                return acc;
            }, {});

            this.movie.allEpisodes = allEpisodes;
            if (Object.keys(formattedActionsObj).length === 0) {
                return [];
            }

            const formattedActionsArr = Object.values(formattedActionsObj)
                .sort((a, b) => a.season - b.season) // Сначала сортируем сезоны
                .map((season) => ({
                    ...season,
                    actions: season.actions.sort(
                        (a, b) => a.episode - b.episode
                    ), // Сортируем эпизоды внутри сезона
                }));

            this.current.totalEpisodes = formattedActionsArr[0].totalEpisodes;
            this.movie.actionsLength = formattedActionsArr[0].totalEpisodes;

            return formattedActionsArr;
        },

        async getSeasonEpisodes(season_id) {
            this.isLoadingVideoEpisodeList = true;
            try {
                const { episodes } = await getVideoEpisodeList(season_id);
                if (episodes.length === 0) {
                    this.isLoadingVideoEpisodeList = false;
                }
                return episodes;
            } catch (error) {
                console.error("Ошибка при получении эпизодов:", error);
                this.isLoadingVideoEpisodeList = false;
                return [];
            }
        },

        formatSeasonsV2(seasons) {
            this.isSeries = true;
            const sortedSeasons = seasons.sort((a, b) => +a.number - +b.number);
            const actions = sortedSeasons.map((el, i) => ({
                ...el,
                actions: [],
                season: (() => {
                    if (
                        typeof el.name === "string" &&
                        el.name.includes("Сезон")
                    ) {
                        const match = el.name.match(/\d+/);
                        return match ? +match[0] : 0;
                    }
                    return +el.number;
                })(),
                number: (() => {
                    if (
                        typeof el.name === "string" &&
                        el.name.includes("Сезон")
                    ) {
                        const match = el.name.match(/\d+/);
                        return match ? +match[0] : 0;
                    }
                    return +el.number;
                })(),
                seasonIndex: i,
                totalEpisodes: 0,
            }));
            const sortedActions = actions.sort((a, b) => a.number - b.number);
            this.getSeasonEpisodes(sortedActions[0].id).then((episodes) => {
                sortedActions[0].actions = this.formatEpisodes(episodes);
                sortedActions[0].totalEpisodes = episodes.length;

                this.current.totalEpisodes = episodes.length;
                this.movie.actionsLength = episodes.length;
            });

            return sortedActions;
        },

        formatEpisodes(actions, season, seasonIndex) {
            if (!actions && actions.length === 0) return;
            let freeActionsIds = [];

            if (this.freeActions.length) {
                freeActionsIds = this.freeActions.map((el) => +el.file_id);
            }

            const initialFormatted = actions.map((el, i) => ({
                ...el,
                file_id: el.files[0]?.id,
                episode_id: el.id,
                id: i + 1,
                season: season >= 0 ? season : this.current.season + 1,
                seasonIndex:
                    seasonIndex >= 0 ? seasonIndex : this.current.season,
                episode: i + 1,
                episodeIndex: i,
                caption: el.name,
                promo_image: el.preview_url,
                isFree:
                    freeActionsIds.length > 0
                        ? freeActionsIds.includes(+el.files[0]?.id)
                        : !this.needSubscription,
            }));
            const formatted = initialFormatted.filter(
                (el) => el.file_id !== undefined
            );
            return formatted;
        },

        getProvider(id) {
            const providerList = {
                1: "megogo",
                2: "amediateka",
                3: "tvcom",
                4: "start",
                6: "wink",
                7: "premier",
                8: "rizaNova",
                9: "tvigle",
                11: "disney",
                14: "viju",
            };

            return providerList[id];
        },

        getFilteredActors(actors) {
            return actors.filter((el) => !!el.name);
        },

        getAboutMoviePosition(movie) {
            if (movie.position_asset_id !== -1) {
                this.isContinue = true;
                if (movie.seasons.length) {
                    if (movie.position_season_id == -1) {
                        this.isContinue = false;
                        return {
                            time: 0,
                            assetId: movie.actions[0].id,
                            seasonId: movie.seasons[0].id,
                        };
                    }
                    const savedPosSeason = this.movie.actions.find(
                        (season) => season.id === movie.position_season_id
                    );

                    this.getSeasonEpisodes(movie.position_season_id).then(
                        (episodes) => {
                            const formatted = this.formatEpisodes(
                                episodes,
                                savedPosSeason.season,
                                savedPosSeason.seasonIndex
                            );
                            this.movie.actions[
                                savedPosSeason.seasonIndex
                            ].actions = formatted;

                            this.movie.actions[
                                savedPosSeason.seasonIndex
                            ].totalEpisodes = formatted.length;

                            const action = formatted.find(
                                (episode) =>
                                    +episode.file_id ===
                                    +movie.position_asset_id
                            );
                            if (action !== undefined) {
                            }

                            this.current.action = action;
                            this.current.season = action.seasonIndex;
                            this.current.episode = action.episodeIndex;
                            this.continuePosVideo = isNaN(action.episodeIndex)
                                ? `Cезон ${action.season} ${
                                      action.episodeIndex + 1
                                  }`
                                : `Cезон ${action.season} Серия ${
                                      action.episodeIndex + 1
                                  }`;

                            this.selectedSeason = savedPosSeason.seasonIndex;
                        }
                    );
                }

                if (
                    movie.is_season &&
                    this.movie.allEpisodes?.length &&
                    !movie.seasons?.length
                ) {
                    const action = this.movie.allEpisodes.find(
                        (el) => +el.file_id === +movie.position_asset_id
                    );
                    if (action) {
                        this.continuePosVideo = isNaN(action.episode)
                            ? `Cезон ${action.season} ${action.episode}`
                            : `Cезон ${action.season} Серия ${action.episode}`;
                        this.selectedSeason = action.season;
                        this.current.season = action.seasonIndex;
                        this.current.episode = action.episodeIndex;
                    }
                }
                if (!movie.is_season && !movie.seasons?.length) {
                    const action = this.movie.actions.find(
                        (el) => +el.file_id === +movie.position_asset_id
                    );

                    if (action) {
                        this.continuePosVideo = action.caption;
                        this.current.season = null;
                        this.current.episode = +action.file_id;
                    }
                }
            }
            if (movie.position_asset_id !== -1) {
                const currentAction = movie.actions.find(
                    (item) => +item.file_id === movie.position_asset_id
                );
                if (currentAction) {
                    this.current.action = currentAction;
                    this.current.caption = currentAction.caption;
                } else {
                    this.isContinue = false;
                    return {
                        time: 0,
                        assetId: movie.actions[0].id,
                        // seasonId: movie.seasons[0].id,
                    };
                }
            }
            return {
                time: movie.position,
                assetId: movie.position_asset_id,
                seasonId: movie.position_season_id,
            };
        },

        formatAboutMovie(movie) {
            const aboutMovie = [
                {
                    title: "originalName",
                    value: movie.originalName,
                },
                {
                    title: "director",
                    value: movie.director,
                },
                {
                    title: "countries",
                    value: movie.countries,
                },
                {
                    title: "provider",
                    value: movie.provider,
                },
            ];

            return aboutMovie.filter((el) => el.value);
        },

        janresFormatter(janres) {
            if (!janres.length) return "";

            const janresArr = janres.split(", ");

            const filteredJanres = janresArr.filter(
                (janr) => !WORD_NOT_VISIBLE_DETAIL_PAGE.includes(janr)
            );

            return filteredJanres.slice(0, 2).join(", ");
        },

        ratingFormatter(rating) {
            if (!+Number(rating).toFixed(1)) return 0;
            return Number(rating).toFixed(1);
        },

        timeConverter(n) {
            if (!n) return 0;

            let num = n;
            let hours = num / 60;
            let rhours = Math.floor(hours);
            let minutes = (hours - rhours) * 60;
            let rminutes = Math.round(minutes);

            const h = rhours ? rhours + "ч. " : "";
            const m = rminutes ? rminutes + "мин." : "";

            const duration = h + m;

            return duration;
        },

        getCinemaBg(provider) {
            const cinemaBg = {
                tvcom: "TVCOM_back_bg",
                megogo: "MEGOGO_back_bg",
                amediateka: "AMEDIATEKA_back_bg",
                start: "START_back_bg",
                wink: "MORE_TV_back_bg",
                premier: "PREMIER_back_bg",
                rizaNova: "RIZA_NOVA_back_bg",
                tvigle: "TVIGLE_NOVA_back_bg",
                disney: "DISNEY_back_bg",
                viju: "VIJU_back_bg",
            };

            const bg = cinemaBg[provider];

            if (bg) return bg;

            return cinemaBg.tvcom;
        },

        // PLAY
        playMovie() {
            this.isPlayingMovie = true;
            this.isPlayingTrailer = false;
            this.addWatchQuery();
        },
        watchMovie() {
            if (this.movie.isSeason) {
                if (this.isPlayingTrailer) {
                    this.setPlayerConfig(this.movie.trailer);
                } else {
                    if (this.freeActions.length === 0) {
                        this.setPlayerConfig(
                            this.movie.actions[this.current.season].actions[
                                this.current.episode
                            ]
                        );
                        this.editTheEpisodIfo(
                            this.current.season,
                            this.current.episode
                        );
                    } else {
                        const action = this.movie.actions[0].actions.find(
                            (el) => +el.file_id === +this.freeActions[0].file_id
                        );
                        this.setPlayerConfig(action);
                    }
                }
            } else {
                try {
                    const action = this.movie.actions.find(
                        (el) => +el.file_id === +this.current.episode
                    );
                    if (this.isPlayingTrailer) {
                        this.setPlayerConfig(this.movie.trailer);
                    } else {
                        this.setPlayerConfig(action || this.movie.actions[0]);
                    }
                } catch (error) {
                    this.setPlayerConfig(this.movie.actions[0] || {});
                }
            }
        },

        // FIXME: возможность смотреть трейлер не авторизованным
        playTrailer() {
            this.isPlayingMovie = false;
            this.isPlayingTrailer = true;
            this.addWatchQuery();
        },
        watchTrailer() {
            this.isPlayingMovie = false;
            this.isPlayingTrailer = true;

            // this.setPlayerConfig(this.movie.trailer);
        },
        // --//-- PLAY
        handleSeasonChange(action) {
            this.changeSeason(action);
            this.changeSeasonActive(action);
        },
        changeSeason(action) {
            const currentSeasonActions =
                this.movie.actions[action.seasonIndex].actions;
            if (!currentSeasonActions.length) {
                this.current.totalEpisodes = 0;
                this.getSeasonEpisodes(action.id).then((episodes) => {
                    const res = this.formatEpisodes(
                        episodes,
                        action.season,
                        action.seasonIndex
                    );

                    this.movie.actions[action.seasonIndex].actions = res;

                    this.movie.actions[action.seasonIndex].totalEpisodes =
                        res.length;

                    this.current.totalEpisodes = res.length;
                });
            } else {
                const seasonLength =
                    this.movie.actions[action.seasonIndex].totalEpisodes;

                this.current.totalEpisodes = seasonLength;
                this.movie.actionsLength = seasonLength;
            }
        },
        changeSeasonActive(action) {
            this.selectedSeason = action.seasonIndex;
        },

        changeEpisode(action) {
            if (!action.isFree) {
                if (this.$route.query.watch) {
                    this.$router.go(-1);
                    this.isPlayingMovie = false;
                    this.isPlayingTrailer = false;
                    setTimeout(() => {
                        this.openPaymnetModal();
                    }, 300);
                    return;
                }
                this.openPaymnetModal();
                return;
            }
            this.movie.actionsLength =
                this.movie.actions[action.seasonIndex].totalEpisodes;
            this.isPlayingMovie = true;
            this.movie.position.time = 0;
            this.current.action = action;
            this.current.season = action.seasonIndex;
            this.current.episode = action.episodeIndex;
            this.editTheEpisodIfo(action.seasonIndex, action.episodeIndex);

            this.episodeId = this.movie.actions[
                action.seasonIndex
            ].actions.findIndex((el) => +el.file_id === +action.file_id);
            this.isContinue = false;
            if (this.movie.actionsLength - 1 === this.current.episode) {
                const nextSeason = this.movie.actions[this.current.season + 1];
                if (nextSeason) {
                    this.changeSeason(nextSeason);
                }
            }
            if (this.current.episode === 0) {
                const prevSeason = this.movie.actions[this.current.season - 1];
                if (prevSeason) {
                    this.changeSeason(prevSeason);
                }
            }

            this.addWatchQuery();
            this.setPlayerConfig(action);
        },
        changeQuality() {
            const findAction = this.movie.actions.find(
                (el) => el.file_id !== this.current.action.file_id
            );
            if (findAction) {
                this.changeQuality_FHD_or_4K(findAction);
            }
        },
        changeQuality_FHD_or_4K(action) {
            this.isPlayingTrailer = false;
            this.isPlayingMovie = true;
            this.current.caption = action.caption;
            this.movie.position.time = 0;
            this.current.action = action;
            this.isContinue = false;
            this.addWatchQuery();
            this.setPlayerConfig(action);
            this.current.episode = +action.file_id;
            this.continuePosVideo = action.caption;
        },

        async favouriteToggle() {
            if (!this.isLoggedIn) {
                this.openAuth();
                return;
            }
            const favourite = this.movie.isFavourite ? 0 : 1;

            const res = await likeMovie(this.id, favourite);

            if (!res.error) this.movie.isFavourite = favourite;
        },

        stringToArray(string) {
            if (!string) return null;
            const fullArr = string.split(",");
            const firstFive = fullArr.slice(0, 5);
            return firstFive;
        },

        async getSimilarMovie() {
            const actorsNames = this.movie.actors
                .map((el) => el.name)
                .slice(0, 5);
            const ageRating = this.movie.ageRating;
            const params = {
                q: this.movie.name,
                age_rating: parseInt(ageRating, 10),
                genres: this.stringToArray(this.movie.genres),
                countries: this.stringToArray(this.movie.countries),
                actors: actorsNames,
                directors: this.stringToArray(this.movie.director),
                languages: this.movie.language,
            };
            const res = await fetchSearchSimilar(1, params);
            const filteredSimilar = res
                .slice(0, 12)
                .filter((el) => +el.id !== +this.id);
            this.similarMovies = filteredSimilar;
        },

        // HLS player
        setPlayerConfig(videoAction) {
            let action;
            if (this.isPlayingTrailer) {
                this.movie.chapter = videoAction.caption;
                action = videoAction;
                this.current.action = action;

                this.fetchVideoSource(action.video_id, action.file_id);
                return;
            }

            if (this.isContinue && this.movie.isSeason) {
                if (this.current.action.id) {
                    action = this.current.action;
                    this.current.action = action;
                } else {
                    const isActionCurrent = this.movie.allEpisodes.some(
                        (item) => +item.file_id === this.movie.position.assetId
                    );

                    if (!isActionCurrent) {
                        action = this.movie.allEpisodes[0];
                    } else {
                        action = this.movie.allEpisodes.find(
                            (el) => +el.file_id === this.movie.position.assetId
                        );
                    }
                    this.current.action = action;
                }
                const currentVideo = this.allActions.find(
                    (el) => +el.episode_id === action.episode_id
                );
                this.selectedSeason = action.seasonIndex;
                this.current.season = action.seasonIndex;
                this.current.episode = action.episodeIndex;
                this.episodeId = this.movie.actions[
                    action.seasonIndex
                ].actions.findIndex((el) => +el.file_id === +action.file_id);
                this.movie.actionsLength =
                    this.movie.actions[action.seasonIndex].totalEpisodes;
                if (action.files[0]?.name) {
                    this.movie.chapter = action.files[0]?.name;
                } else {
                    this.movie.chapter = `"Сезон ${action.season} ${action.caption}"`;
                }

                this.fetchVideoSource(action.video_id, action.file_id);
                return;
            }
            const currentVideo = this.allActions.find(
                (el) => +el.episode_id === videoAction.episode_id
            );

            if (this.movie.isSeason) {
                if (videoAction.files[0]?.name) {
                    this.movie.chapter = videoAction.files[0]?.name;
                } else {
                    this.movie.chapter = `"Сезон ${videoAction.season} ${videoAction.caption}"`;
                }
                action = videoAction;
            } else {
                if (this.isContinue) {
                    const currentAction = this.movie.actions.find(
                        (item) => +item.file_id === this.movie.position.assetId
                    );
                    action = currentAction;
                } else {
                    const actionItem = videoAction;
                    this.movie.chapter = actionItem.caption;
                    this.current.caption = actionItem.caption;
                    action = actionItem;
                }
            }

            this.current.action = action;
            this.fetchVideoSource(action.video_id, action.file_id);
        },

        async fetchVideoSource(videoId, videoFileId) {
            let firstVideoId;
            let lastVideoId;
            if (!this.movie.isSeason) {
                const withoutTrailer = this.movie.actions.filter((item) => {
                    return item.action !== "get_trailer_url";
                });
                if (this.isPlayingMovie) {
                    firstVideoId = withoutTrailer[0]?.file_id;
                    lastVideoId =
                        withoutTrailer[withoutTrailer.length - 1]?.file_id;
                } else {
                    firstVideoId = videoFileId;
                    lastVideoId = videoFileId;
                }
            } else {
                const withoutTrailer = this.allActions.filter((item) => {
                    return item.action !== "get_trailer_url";
                });
                firstVideoId = withoutTrailer[0]?.file_id;
                lastVideoId =
                    withoutTrailer[withoutTrailer.length - 1]?.file_id;
            }
            this.episodeIds.currentMovieId = videoFileId;
            this.episodeIds.firstMovieId = firstVideoId;
            this.episodeIds.lastMovieId = lastVideoId;

            const data = await getMovieUrl(videoId, videoFileId);

            this.videoExtraData = {
                opening_start: data.opening_start,
                opening_end: data.opening_end,
                title_start: data.title_start,
            };

            if (data.error) {
                this.hlsSource = "error";
                this.isLoding = false;
                return;
            }
            let uri = data.uri.replace("http:", "https:").replace(":8180", "");

            uri = uri.includes("-4K.mp4")
                ? uri.replace("index.m3u8", "index.fmp4.m3u8")
                : uri;
            this.hlsSource = uri;
            this.forProblemsInfo.video_url = uri;
            this.isLoding = false;

            return uri;
        },

        async saveContentPosition(currentTime) {
            if (this.isPlayingTrailer) return;

            const { video_id, file_id } = this.current.action;
            if (this.movie.isSeason) {
                this.continuePosVideo = isNaN(this.current.action.episodeIndex)
                    ? `Cезон ${this.current.action.season} ${
                          this.current.action.episodeIndex + 1
                      }`
                    : `Cезон ${this.current.action.season} Серия ${
                          this.current.action.episodeIndex + 1
                      }`;
            } else {
                this.continuePosVideo = this.current.action.caption;
            }

            await addViewed({
                vid: video_id,
                assetsId: file_id,
                position: currentTime,
            });

            this.movie.position.time = currentTime;
        },

        async statVideoPush(currentTime) {
            if (this.isPlayingTrailer) return;

            const { video_id } = this.current.action;

            await VIDEO_STATS_API.statsMoviePush({
                video_id,
                video_position: currentTime.toFixed(0),
            });
        },

        nextEpisode() {
            if (!this.movie.isSeason) {
                const video = this.movie.actions[1];
                this.changeQuality_FHD_or_4K(video);
            } else {
                if (this.freeActions.length > 0) {
                    if (this.$route.query.watch) {
                        this.$router.go(-1);
                        this.isPlayingMovie = false;
                        this.isPlayingTrailer = false;
                        setTimeout(() => {
                            this.openPaymnetModal();
                        }, 300);
                        return;
                    }
                    return;
                }
                const { actions } = this.movie.actions[this.current.season];
                const totalEpisodes = this.allActions.length;
                const totlaSeasons = this.movie.actions.length;
                const LastEpisodOfCurrentSeason =
                    actions[actions.length - 1].episode_id;
                const currentVideoEpisodeId =
                    actions[this.current.episode].episode_id;
                const lastEpisodId =
                    this.allActions[totalEpisodes - 1].episode_id;
                if (
                    currentVideoEpisodeId ===
                    actions[actions.length - 2].episode_id
                ) {
                    const nextSeason =
                        this.movie.actions[this.selectedSeason + 1];
                    if (nextSeason) {
                        this.changeSeason(nextSeason);
                    }
                }
                if (currentVideoEpisodeId !== +lastEpisodId) {
                    this.current.episode += 1;
                    this.episodeId += 1;
                }
                if (
                    currentVideoEpisodeId === LastEpisodOfCurrentSeason &&
                    this.current.season < totlaSeasons - 1
                ) {
                    this.current.season += 1;
                    this.selectedSeason += 1;
                    this.current.episode = 0;
                }
                if (this.selectedSeason !== this.current.season) {
                    this.selectedSeason = this.current.season;
                }
                const episode =
                    this.movie.actions[this.current.season].actions[
                        this.current.episode
                    ];
                const currentVideo = this.allActions.find(
                    (el) => +el.episode_id === episode.episode_id
                );
                this.movie.position.time = 0;
                this.current.action = currentVideo;
                this.movie.chapter = currentVideo?.caption;
                this.fetchVideoSource(
                    currentVideo.video_id,
                    currentVideo.file_id
                );
            }
        },

        prevEpisode() {
            if (!this.movie.isSeason) {
                const video = this.movie.actions[0];
                this.changeQuality_FHD_or_4K(video);
                return;
            }
            const { actions } = this.movie.actions[this.current.season];
            const firstEpisodeOfCurrentSeason = actions[0].episode_id;
            const currentVideoEpisodeId =
                actions[this.current.episode].episode_id;
            const firstEpisodeId = this.allActions[0].episode_id;

            if (currentVideoEpisodeId === actions[1].episode_id) {
                const prevSeason = this.movie.actions[this.selectedSeason - 1];
                if (prevSeason) {
                    this.changeSeason(prevSeason);
                }
            }

            if (currentVideoEpisodeId !== firstEpisodeId) {
                this.current.episode -= 1;
                this.episodeId -= 1;
            }

            if (
                currentVideoEpisodeId === firstEpisodeOfCurrentSeason &&
                this.current.season > 0
            ) {
                this.current.season -= 1;
                this.selectedSeason -= 1;
                const prevSeasonActions =
                    this.movie.actions[this.current.season].actions;
                this.current.episode = prevSeasonActions.length - 1;
            }

            if (this.selectedSeason !== this.current.season) {
                this.selectedSeason = this.current.season;
            }
            const episode =
                this.movie.actions[this.current.season].actions[
                    this.current.episode
                ];
            const currentVideo = this.allActions.find(
                (el) => +el.episode_id === episode.episode_id
            );

            this.movie.position.time = 0;
            this.current.action = currentVideo;
            this.movie.chapter = currentVideo?.caption;
            this.fetchVideoSource(currentVideo.video_id, currentVideo.file_id);
        },

        // --//-- HLS player

        resetScroll() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
    },
};
</script>
<style lang="scss">
.hero {
    .el-button {
        &__text {
            position: static;
        }
        .decor {
            position: absolute;
            top: 0;
            right: 0;
            width: 80px;
            border-top-right-radius: var(--border-radius);
        }
    }
}
</style>
<style lang="scss" scoped>
@mixin itemColumnWidth($item, $gap) {
    width: calc(100% / $item - (($item - 1) * $gap) / $item);
}
.moviePage {
    min-height: 100vh;
    .container {
        width: 90%;
        margin: 0 auto;
    }
    .background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        user-select: none;
        &__img {
            width: 100%;
            height: 100%;
            position: relative;
            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
                background: linear-gradient(
                    180deg,
                    #000 2.52%,
                    rgba(0, 0, 0, 0) 70%
                );
            }
            &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
                background: linear-gradient(
                    90deg,
                    #000 15.14%,
                    rgba(0, 0, 0, 0) 45.43%
                );
            }
        }
        img {
            width: 100%;
            height: 100%;
            filter: blur(15px);
            object-fit: cover;
        }
    }
}
@mixin loader {
    background: linear-gradient(100deg, #3f3f3f 30%, #e41a4b 50%, #3f3f3f 70%);
    background-size: 500%;
    animation: loading 1s ease-in-out infinite;
    border-radius: 10px;
}
@mixin itemColumnWidthP($item, $gap) {
    min-width: calc(100% / $item - (($item - 1) * $gap) / $item) !important;
}
@mixin itemColumnWidth($item, $gap) {
    width: calc(100% / $item - (($item - 1) * $gap) / $item) !important;
}
.unAuthorizeModal {
    position: fixed;
    top: 50%;
    left: 0;
    width: 100%;
    height: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    overflow: hidden;
    transition: 0.3s;
    background: rgba(0, 0, 0, 0.5);
    &__wrapper {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        background: #262626;
        padding: 30px;
        width: 90%;
        max-width: 500px;
        border-radius: 10px;
        opacity: 0;
        transition: 0.3s ease 0.3s;
        .text {
            font-size: 22px;
            font-weight: bold;
            text-align: center;
        }
        .btns {
            display: flex;
            align-items: center;
            gap: 20px;
            .btn {
                border: none;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                padding: 10px 20px;
                font-size: 17px;
                font-weight: 500;
                cursor: pointer;
                transition: 0.2s;
                color: #fff;
                background: #322f2f;
                &.auth {
                    background: #e41a4b;
                }
                &:hover {
                    opacity: 0.7;
                }
            }
        }
    }
    &.open {
        top: 0;
        height: 100%;
        .unAuthorizeModal {
            &__wrapper {
                opacity: 1;
            }
        }
    }
}
.skeleton {
    &__wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 90px;
        padding-bottom: 30px;
    }
    &__left {
        &_wrapperImg {
            width: 16.5vw;
            min-width: 200px;
            max-width: 350px;
            margin-bottom: 30px;
        }
        &_img {
            padding-bottom: 137%;
            position: relative;
            .img {
                border-radius: 10px;
                height: 100%;
                width: 100%;
                object-fit: cover;
                position: absolute;
                inset: 0;
                @include loader;
            }
        }
    }
    &__right {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 50%;
        &_title {
            @include loader;
            height: 3.023vw;
            max-height: 73.6px;
            min-height: 30.4px;
            width: 100%;
            max-width: 600px;
            margin-bottom: 15px;
        }
        &_items {
            display: flex;
            flex-wrap: wrap;
            row-gap: 30px;
            column-gap: 30px;
            list-style: none;
            margin-bottom: 40px;
            &_item {
                @include loader;
                height: 24px;
                width: 100px;
            }
        }
        &_btn {
            width: 300px;
            height: 50px;
            @include loader;
        }
    }
    &__miniBtns {
        display: none;
    }
    &__seriesList {
        display: flex;
        row-gap: 20px;
        column-gap: 30px;
        overflow: hidden;
        &.listOpen {
            flex-wrap: wrap;
        }
        @media (max-width: 1919.98px) {
            column-gap: 30px;
        }
        @media (max-width: 1439.98px) {
            column-gap: 25px;
        }
        @media (max-width: 1199.98px) {
            column-gap: 20px;
        }
        @media (max-width: 767.98px) {
            column-gap: 15px;
        }
        @media (max-width: 576px) {
            column-gap: 15px;
        }
        &_item {
            display: flex;
            flex-direction: column;
            gap: 10px;
            cursor: pointer;
            @include itemColumnWidthP(6, 30px);
            @media (max-width: 1919.98px) {
                @include itemColumnWidthP(5, 30px);
            }
            @media (max-width: 1439.98px) {
                @include itemColumnWidthP(4, 25px);
            }
            @media (max-width: 1199.98px) {
                @include itemColumnWidthP(3, 20px);
            }
            @media (max-width: 767.98px) {
                @include itemColumnWidthP(2, 15px);
            }
            @media (max-width: 576px) {
                @include itemColumnWidthP(2, 15px);
            }
            &_imgWrapper {
                position: relative;
                width: 100%;
                padding-bottom: 62%;
                &_img {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    inset: 0;
                    @include loader;
                }
            }
        }
    }
}
@keyframes loading {
    0% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}
.series__list {
    display: flex;
    column-gap: 30px;
    row-gap: 20px;
    padding-top: 20px;
}
.series_item {
    @include itemColumnWidth(7, 23px);
}
@media (max-width: 1919.98px) {
    .series_item {
        @include itemColumnWidth(5, 30px);
    }
}
@media (max-width: 1439.98px) {
    .series_item {
        @include itemColumnWidth(4, 25px);
    }
}
@media (max-width: 1199.98px) {
    .series_item {
        @include itemColumnWidth(3, 20px);
    }
}
@media (max-width: 767.98px) {
    .series_item {
        @include itemColumnWidth(2, 15px);
    }
}
@media (max-width: 576px) {
    .series_item {
        @include itemColumnWidth(2, 15px);
    }
    .series__list {
        column-gap: 15px;
    }
}

.hero {
    --buttonsHeight: 58px;
    position: relative;
    overflow: hidden;
    &.section {
        margin-bottom: 30px;
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: linear-gradient(0deg, #000 2.52%, rgba(0, 0, 0, 0) 38.39%);
    }
    &__wrapper {
        display: flex;
        gap: 30px;
        justify-content: space-between;
        align-items: flex-start;
        padding-top: 90px;
        padding-bottom: 30px;
        position: relative;
        z-index: 2;
    }
    &__content__imgWrapper {
        width: 16.5vw;
        min-width: 200px;
        max-width: 350px;
        margin-bottom: 30px;
    }
    &__img {
        padding-bottom: 137%;
        position: relative;
        user-select: none;
        @include loader;
        display: flex;
        align-items: flex-start;
        img {
            border-radius: 10px;
            height: 100%;
            width: 100%;
            object-fit: cover;
            position: absolute;
            inset: 0;
            user-select: none;
            opacity: 0;
            transition: 0.3s ease;
        }
        &.isImageLoaded {
            background: none;
            img {
                opacity: 1;
            }
        }
        &_provider {
            position: absolute;
            top: 5px;
            left: 5px;
            z-index: 3;
            width: 110px;
            img {
                border-radius: 5px;
                height: 30px;
                opacity: 1;
                position: relative;
            }
        }
    }

    &__content {
        display: flex;
        width: 100%;
        justify-content: space-between;
        gap: 30px;
        position: relative;
        flex-wrap: wrap;
        &__left {
            display: flex;
            flex-direction: column;
            max-width: 55%;
        }
        &__right {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            &_wrapper {
                display: flex;
                justify-content: center;
                align-items: flex-start;
                gap: 18px;
            }
            &_button {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .icon {
                    width: var(--buttonsHeight);
                    height: var(--buttonsHeight);
                    flex-shrink: 0;
                    border: none;
                    outline: none;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 12px;
                    background: #292929;
                    color: #fff;
                }
                .el-button {
                    --svg--size: 100%;
                }
                &--ITrailer,
                &--IStar {
                    display: none;
                }

                .text {
                    display: none;
                }
                &--active {
                    .el-button {
                        svg {
                            fill: #e41a4b;
                            animation: bounce 0.2s ease-in-out;
                        }
                        @keyframes bounce {
                            0% {
                                scale: 1;
                            }
                            80% {
                                scale: 1.2;
                            }
                            100% {
                                scale: 1;
                            }
                        }
                    }
                }
            }
        }
    }
    &__title {
        font-size: clamp(20px, 2.5vw, 60px);
        font-weight: 600;
        margin-bottom: 15px;
    }
    &__items {
        display: flex;
        flex-wrap: wrap;
        row-gap: 30px;
        column-gap: 30px;
        list-style: none;
        margin-bottom: 40px;
        &_item {
            font-size: 18px;
            opacity: 0.7;
            font-weight: 500;
            &--red {
                color: #e41a4b;
            }
            &--age {
                position: absolute;
                top: 0;
                right: 0;
                width: 56px;
                height: 56px;
                border-radius: 12px;
                background: rgba(255, 255, 255, 0.25);
                display: flex;
                justify-content: center;
                align-items: center;
                color: #000;
                text-align: center;
                font-size: 20px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
            &--mobile {
                display: none;
            }
        }
    }
    &__ratings_wrapper {
        display: flex;
        column-gap: 40px;
        row-gap: 30px;
        flex-wrap: wrap;
        margin-bottom: 40px;
    }

    &__buttons {
        display: flex;
        gap: 18px;
        &_btn {
            height: var(--buttonsHeight);
            padding: 0 35px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 15px;
            font-size: 20px;
            font-weight: 500;
            border: none;
            outline: none;
            background: #e41a4b;
            color: #fff;
            cursor: pointer;
            &--watch {
                // width: 300px;
                position: relative;
                &::after {
                    content: attr(data-continue-video);
                    position: absolute;
                    bottom: -30px;
                    left: 0;
                    width: 100%;
                    background: transparent;
                    font-size: 16px;
                    color: #797979;
                    text-align: center;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            &--trailer {
                background: #292929;
            }
        }
    }
}
.section {
    margin-bottom: 60px;
}
.movieInfo {
    &__wrapper {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }
    &__head {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 18px;
        list-style: none;
        overflow-y: auto;
        &::-webkit-scrollbar {
            display: none;
        }
        &_item {
            &_btn {
                padding: 10px;
                border: none;
                outline: none;
                color: #707070;
                text-align: center;
                font-size: 20px;
                font-style: normal;
                white-space: nowrap;
                font-weight: 500;
                line-height: normal;
                background: transparent;
                cursor: pointer;
                position: relative;
                transition: 0.3s ease;
                &::before {
                    position: absolute;
                    content: "";
                    width: 0;
                    height: 2px;
                    background: #fff;
                    bottom: 0;
                    left: 0;
                    transition: 0.3s ease;
                }
                &:hover {
                    &::before {
                        width: 100%;
                    }
                }
                &--active {
                    color: #fff;
                    &::before {
                        width: 100%;
                        background: #e41a4b;
                    }
                }
            }
        }
    }
    &__content {
        &_description {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 30px;
            &_text {
                color: #fff;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 24px */
                min-width: 600px;
                flex: 1;
                &_content {
                    margin-bottom: 30px;
                    display: flex;
                }
            }
            &_rate {
                .hero__ratings {
                    display: none;
                }
            }
        }
        &_actors {
            // max-width: 1920px;
        }
        &_tarrifList {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
            gap: 15px;
            width: 100%;
            @media (min-width: 2000px) {
                grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
            }

            @media (max-width: 1987px) {
                grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
            }

            @media (max-width: 1760px) {
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            }
        }
        .actors_list {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            grid-auto-rows: min-content;
            gap: 18px;
            overflow: hidden;
            width: 100%;
            padding-right: 10px;
            transition: 0.4s ease;
        }
        .actor_item {
            display: grid;
            grid-template-columns: 70px 1fr;
            align-items: center;
            gap: 10px;
            border-radius: 100px;
            background: #262626;
            padding: 8.5px 9px 8.5px 9px;
            cursor: pointer;
            transition: 0.2s;
            position: relative;
            overflow: hidden;
        }
        .actor_item > span {
            font-size: 14px;
            font-weight: 400;
            color: #e3e3e3;
            position: absolute;
            top: 0;
            right: 0;
            font-size: 12px;
            font-weight: 400;
            line-height: 13.9px;
            text-align: left;
            padding: 0 22px 0 13px;
            background: #d9d9d9;
            color: #000;
            border-bottom-left-radius: 16px;
        }
        .actor_item.director {
            order: -1;
        }
        .actor_item_name {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }

        .actor_item:hover {
            opacity: 0.7;
        }

        .actor_item > img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: 100px;
            background: #363636;
        }

        .actor_stock_img {
            object-fit: scale-down !important;
        }

        .actor_item_name > h3 {
            font-size: 20px;
            font-weight: 400;
            color: #e3e3e3;
            display: flex;
            flex-direction: column;
        }
    }
    &__list {
        display: flex;
        flex-direction: column;
        list-style: none;
        &_item {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 10px;
            padding: 10px 0;
            opacity: 0.8;
            &:not(:last-child) {
                border-bottom: 1px solid #a19f9f33;
            }
            p {
                color: #fff;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                flex: 1;
            }
            &_value {
                text-align: right;
            }
        }
    }
}

.seasonSeries {
    .skeleton {
        padding-top: calc(54px + 20px);
    }
    &__navigation {
        &_title {
            color: #fff;
            font-size: 32px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
        }
    }
}

@media (max-width: 991.98px) {
    .moviePage {
        .background {
            &__img {
                &::after {
                    display: none;
                }
                &::before {
                    display: none;
                }
            }
        }
    }
    .section {
        margin-bottom: 40px;
    }
    .skeleton {
        &__left {
            &_wrapperImg {
                width: 60%;
                align-self: center;
            }
            &_img {
                padding-bottom: 150%;
            }
        }
        &__right {
            max-width: 100%;
            &_title {
                height: 36px;
                max-height: unset;
                min-height: unset;
                width: 100%;
                max-width: 100%;
                margin-bottom: 20px;
            }
            &_items {
                row-gap: 20px;
                column-gap: 20px;
                margin-bottom: 20px;
                &_item {
                    @include loader;
                    width: calc(25% - 60px / 4);
                }
            }
            &_movieRating {
                display: none;
            }
            &_ratings_wrapper {
                column-gap: 20px;
                row-gap: 20px;
            }
            &_ratings {
                gap: 20px;
                &_item {
                    &_img {
                        width: 80px;
                    }
                }
            }
            &_btn {
                width: 100%;
                height: 60px;
                margin-bottom: 45px;
            }
        }
        &__miniBtns {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            gap: 15px;
            &__item {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                gap: 6px;
                &_icon {
                    width: 56px;
                    height: 56px;
                    @include loader;
                    border-radius: 50%;
                }
                &_text {
                    @include loader;
                    width: 75px;
                    height: 13px;
                }
            }
        }
    }
    .moviePage {
        .container {
            width: 100%;
            padding: 0 20px;
        }
    }
    .hero {
        --buttonsHeight: 70px;

        &__content__imgWrapper {
            width: 60%;
            align-self: center;
        }
        &__content {
            gap: 45px;
            flex-direction: column;
            width: 100%;
            &__left {
                max-width: 100%;
                width: 100%;
            }
            &__right {
                &_wrapper {
                    gap: 15px;
                    justify-content: space-evenly;
                }
                &_button {
                    position: relative;
                    gap: 6px;
                    cursor: pointer;
                    .icon {
                        width: 56px;
                        height: 56px;
                        border-radius: 50%;
                        &:after {
                            content: "";
                            position: absolute;
                            inset: 0;
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }
                    &--ITrailer,
                    &--IStar {
                        display: flex;
                    }
                    &--ISound {
                        display: none;
                    }
                    &--IShare {
                        span {
                            width: 100%;
                            height: 100%;
                            .icon {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .text {
                            visibility: hidden;
                        }
                    }
                    .text {
                        display: flex;
                        color: #fff;
                        text-align: center;
                        font-size: 11px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                    }
                }
            }
        }
        &__title {
            color: #fff;
            font-size: 32px;
            font-style: normal;
            font-weight: 400;
            line-height: 112.9%; /* 36.128px */
            margin-bottom: 20px;
        }
        &__img {
            padding-bottom: 150%;
        }
        &__items {
            row-gap: 20px;
            column-gap: 20px;
            margin-bottom: 20px;
            &_item {
                font-size: 20px;
                font-weight: 600;
                &--red {
                    color: #e41a4b;
                }
                &--age {
                    position: relative;

                    width: auto;
                    height: auto;
                    border-radius: 0;
                    background: transparent;
                    color: #e41a4b;
                }
                &--mobile {
                    display: flex;
                }
            }
        }
        &__ratings_wrapper {
            row-gap: 20px;
            column-gap: 20px;
            margin-bottom: 20px;
        }
        .raitingMovie__item {
            display: none;
        }
        &__ratings {
            gap: 20px;
        }
        &__buttons {
            display: flex;
            gap: 18px;
            &_btn {
                height: var(--buttonsHeight);
                &--watch {
                    width: 100%;
                }
                &--trailer {
                    display: none;
                }
            }
            .el-button {
                width: 100%;
            }
        }
        .hero__content__right_button {
            .el-button {
                --border-radius: 50%;
            }
        }
    }
    .movieInfo {
        &.section {
            margin-bottom: 50px;
        }
        &__content {
            &_description {
                font-size: 12px;
                &_text {
                    min-width: 100%;
                }
                &_rate {
                    .hero {
                        &__ratings {
                            display: flex;
                            gap: 30px;
                            flex-wrap: wrap;
                            list-style: none;
                            &_item {
                                display: flex;
                                align-items: center;
                                gap: 10px;
                                &_img {
                                    width: 30px;
                                    height: 30px;
                                    img {
                                        width: 100%;
                                        height: 100%;
                                        border-radius: 5px;
                                    }
                                }
                                &_number {
                                    font-size: 24px;
                                    font-weight: 600;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 575.98px) {
    .section {
        margin-bottom: 20px;
    }
    .movieInfo {
        &__wrapper {
            gap: 20px;
        }
        &__head {
            &_item {
                &_btn {
                    padding: 10px 0;
                }
            }
        }
        &__content {
            &_description {
                &_text {
                    font-size: 14px;
                }
                &_rate {
                    .hero__ratings {
                        justify-content: space-between;
                    }
                }
            }
            .actors_list {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                grid-auto-rows: min-content;
                gap: 18px;
                overflow: hidden;
                width: 100%;
                padding-right: 10px;
                transition: 0.4s ease;
            }
            .actor_item {
                display: grid;
                grid-template-columns: 70px 1fr;
                align-items: center;
                gap: 10px;
                border-radius: 100px;
                background: #262626;
                padding: 8.5px 9px 8.5px 9px;
                cursor: pointer;
                transition: 0.2s;
                position: relative;
                overflow: hidden;
            }
            .actor_item > span {
                font-size: 14px;
                font-weight: 400;
                color: #e3e3e3;
                position: absolute;
                top: 0;
                right: 0;
                font-size: 12px;
                font-weight: 400;
                line-height: 13.9px;
                text-align: left;
                padding: 0 22px 0 13px;
                background: #d9d9d9;
                color: #000;
                border-bottom-left-radius: 16px;
            }
            .actor_item.director {
                order: -1;
            }
            .actor_item_name {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
            }

            .actor_item:hover {
                opacity: 0.7;
            }

            .actor_item > img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                border-radius: 100px;
                background: #363636;
            }

            .actor_stock_img {
                object-fit: scale-down !important;
            }

            .actor_item_name > h3 {
                font-size: 20px;
                font-weight: 400;
                color: #e3e3e3;
                display: flex;
                flex-direction: column;
            }
        }
        &__list {
            &_item {
                p {
                    font-size: 14px;
                }
            }
        }
    }
    .hero {
        --buttonsHeight: 58px;
        &__title {
            font-size: 32px;
            font-weight: 400;
        }
        &__items {
            row-gap: 15px;
            column-gap: 15px;
            margin-bottom: 30px;
            &_item {
                font-size: 14px;
            }
        }
        &__buttons {
            .hero__content__right_button {
                .icon {
                    height: 58px;
                    width: 58px;
                }
            }
        }
    }
    .skeleton {
        &__right {
            &_items {
                margin-bottom: 30px;
                &_item {
                    @include loader;
                    width: calc(25% - 60px / 4);
                    height: 15px;
                }
            }
        }
        &__miniBtns {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            gap: 15px;
            &__item {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                gap: 6px;
                &_icon {
                    width: 56px;
                    height: 56px;
                    @include loader;
                    border-radius: 50%;
                }
                &_text {
                    @include loader;
                    width: 75px;
                    height: 13px;
                }
            }
        }
    }
}
</style>
